import { Component, Inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { KindService } from 'app/services/models/kind.service';
import { ProcedureService } from 'app/services/models/procedure.service';
import { ReferenceService } from 'app/services/models/reference.service';
import { ToastrService } from 'ngx-toastr';
import Quill from 'quill';

@Component({
  selector: 'app-procedure-dialog',
  templateUrl: './procedure-dialog.component.html',
  styleUrls: ['./procedure-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProcedureDialogComponent implements OnInit {
  @Input() data;
  form: FormGroup;
  kinds: any[] = [];
  procedure: any;
  selectedFile: File | null = null;   // ✅ Seçilen dosya burada tutulacak
  fileList: { id?: number; formNo: string, filePath?: File | null, isActive: boolean }[] = [];
  references: any[] = [];
  quillConfig = {
    toolbar: {
      container: [
        [{ 'font': [] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'size': ['small', 'medium'] }],
      ]
    }
  }

  constructor(
    public ngbModal: NgbActiveModal,
    private fb: FormBuilder,
    private kindService: KindService,
    private procedureService: ProcedureService,
    private toastrService: ToastrService,
    private referenceService: ReferenceService,
    @Inject('backendUrl') public backendUrl: string,
  ) { }

  async ngOnInit() {
    this.initializeForm(); // Formu hemen başlat
    if (this.data) {
      await this.getByIdProcedure(this.data);
    }

    await this.getAllKinds();
    await this.getAllReference(this.procedure.kindId);
  }

  async getByIdProcedure(id) {
    const proc = await this.procedureService.getByIdProcedure(this.data);
    this.procedure = proc;
    console.log(this.procedure);
    this.form.patchValue({
      name: this.procedure.name,
      kindId: this.procedure.kindId,
      status: this.procedure.status,
      description: this.procedure.description,
      formNo: this.procedure.formNo,
      referenceId: this.procedure.referenceId
    });

    if (this.procedure.procedureFiles && this.procedure.procedureFiles.length > 0) {
      this.fileList = this.procedure.procedureFiles.map(file => ({
        id: file.id,                     // ✅ doğru alan adı
        formNo: file.formNo,
        filePath: file.filePath, // burada string (URL) olarak kalır
        isActive: file.isActive
      }));
    } else {
      this.fileList = [];
    }
  }

  async getAllReference(kindId) {
    const data = await this.referenceService.getAllReference(0, 1000, kindId);
    console.log(data);
    this.references = data.references;
  }

  isDisabled() {
    return this.data === 1 || this.data === 2 || this.data === 3 || this.data === 4 || this.data === 5 || this.data === 6;
  }

  initializeForm() {
    this.form = this.fb.group({
      name: ['', Validators.required],
      kindId: [null, Validators.required],
      status: [true],
      description: [''],
      formNo: [null],
      createProcedureFileDtos: [[]],
      updateProcedureFileDto: [[]],
      referenceId: [null]
    });
  }

  addFileItem() {
    this.fileList.push({ formNo: null, filePath: null, isActive: false });
  }

  removeFileItem(index: number) {
    this.fileList.splice(index, 1);
  }

  onFileSelected(event: any, index: number) {
    const files = event.target.files;
    if (files && files.length > 0) {
      // Çoklu dosya seçimi desteği
      for (let i = 0; i < files.length; i++) {
        if (i === 0) {
          this.fileList[index].filePath = files[i];
        } else {
          this.fileList.push({
            formNo: '',
            filePath: files[i],
            isActive: true,
          });
        }
      }
    }
    console.log(this.fileList);
  }

  setSingleActive(index: number) {
    this.fileList.forEach((file, i) => {
      // Sadece seçilen index aktif, diğerleri pasif
      file.isActive = i === index ? !file.isActive : false;
    });

    // Eğer yeni seçilen zaten aktifti ve tekrar tıklandıysa → hepsi pasif olur
    const activeCount = this.fileList.filter(f => f.isActive).length;
    if (activeCount === 0) {
      this.fileList.forEach(f => f.isActive = false);
    }

    console.log(this.fileList);
  }



  async getAllKinds() {
    const data = await this.kindService.getAllKinds('', 0, 100, 13);
    this.kinds = data.types;
    console.log(this.kinds);
  }

  closeModal() {
    this.ngbModal.close('Modal Kapatıldı.');
  }

  async onSubmit() {
    if (this.form.invalid) return;

    const formValue = { ...this.form.value };
    const formData = new FormData();

    formData.append('name', formValue.name);
    formData.append('kindId', formValue.kindId);
    formData.append('status', formValue.status);
    formData.append('description', formValue.description ?? '');
    formData.append('referenceId', formValue.referenceId ?? null);

    if (this.data) {
      // Update işlemi
      formData.append('id', this.procedure.id);

      this.fileList.forEach((item, i) => {
        formData.append(`updateProcedureFileDto[${i}].id`, (item.id ?? 0).toString());
        formData.append(`updateProcedureFileDto[${i}].procedureId`, (this.procedure.id).toString());

        formData.append(`updateProcedureFileDto[${i}].formNo`, item.formNo ?? '');
        formData.append(`updateProcedureFileDto[${i}].isActive`, item.isActive.toString());
        if (item.filePath) {
          formData.append(`updateProcedureFileDto[${i}].filePath`, item.filePath);
        }
      });
      console.log(formData);

      const res = await this.procedureService.updateProcedure(formData);
      this.handleResponse(res);
    } else {
      // Create işlemi
      this.fileList.forEach((item, i) => {
        formData.append(`createProcedureFileDtos[${i}].formNo`, item.formNo ?? '');
        formData.append(`createProcedureFileDtos[${i}].isActive`, item.isActive.toString());
        if (item.filePath) {
          formData.append(`createProcedureFileDtos[${i}].filePath`, item.filePath);
        }
      });
      console.log(formData);
      const res = await this.procedureService.createProcedure(formData);
      this.handleResponse(res);
    }
  }

  handleResponse(data: any) {
    if (data.status) {
      this.toastrService.success(data.message);
      this.procedureService.sendEvent(true);
      this.closeModal();
    } else {
      this.toastrService.error(data.message);
    }
  }

  async deleteProcedureFile(id: number) {
    const res = await this.procedureService.deleteProcedureFile(id);
    if (res.status == true) {
      this.toastrService.success(res.message);
      await this.getByIdProcedure(this.data);
      this.procedureService.sendEvent(true);
    } else {
      this.toastrService.error(res.message);
    }
  }

  getFileName(i: number): string {
    const file: any = this.fileList[i]?.filePath; // 👈 burada tipini 'any' yaptık

    if (!file) return '';

    // 🟢 1. Yeni seçilen dosya (File objesi)
    if (file instanceof File) {
      return file.name;
    }

    // 🟢 2. Backend’den gelen string path
    if (typeof file === 'string') {
      // 'procedures/....-dosya-adi.pdf'
      const fileName = file.split('/').pop() || '';
      const parts = fileName.split('-');
      // 🟢 5. tireden sonrasını al
      return parts.length > 5 ? parts.slice(5).join('-') : fileName;
    }

    // 🟡 3. Diğer tüm durumlar
    return '';
  }

}